"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MakeFakeQuoteResults = exports.MakeFakeQuoteForPlan = exports.MakeFakeQuoteContext = exports.GetFakeProductQuotes = void 0;
var _MockQuoteResults = require("../mocks/MockQuoteResults");
var _productHelpers = require("./productHelpers");
var _quoteHelpers = require("./quoteHelpers");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var MakeFakeQuoteContext = exports.MakeFakeQuoteContext = function MakeFakeQuoteContext(_ref) {
  var frequency = _ref.frequency,
    addPromo = _ref.addPromo;
  return {
    paymentFrequencyCode: frequency,
    hasPromotionCode: addPromo,
    promotionCode: 'FAKEPROMO5',
    promotionMessage: 'Thanks for using promo code FAKEPROMO5. This offer provides you with $5 off. The offer applies to fake Pet Insurance policies created using the product test harness. This message tests the character coded line breaks in a typical promo message. \rT&Cs Apply.',
    collectionFee: 2
  };
};
var MakeFakeQuoteForPlan = exports.MakeFakeQuoteForPlan = function MakeFakeQuoteForPlan(_ref2) {
  var transformedMockResults = _ref2.transformedMockResults,
    productDefinitions = _ref2.productDefinitions,
    planNumber = _ref2.planNumber;
  var findMatchingProductDefinition = function findMatchingProductDefinition(planNumber) {
    var match;
    Object.values(productDefinitions).forEach(function (productGroup) {
      Object.values(productGroup).forEach(function (plan) {
        if (plan.planNumber === planNumber) {
          match = plan;
        }
      });
    });
    return match;
  };
  var makeFakePlanVariations = function makeFakePlanVariations(planNumber) {
    var demoResult = Object.values(transformedMockResults)[0];
    var demoVariation = demoResult.variations[0];
    var matchingProduct = findMatchingProductDefinition(planNumber);
    var adjustedVariations = matchingProduct.upmExcessOptions.map(function (option, index) {
      var planAdjust = parseInt(planNumber, 10) / 50 + index;
      return _objectSpread(_objectSpread({}, demoVariation), {}, {
        planNumber: planNumber,
        excess: {
          value: option.excess,
          code: option.excessCode
        },
        levelOfCover: _objectSpread(_objectSpread({}, demoVariation.levelOfCover), {}, {
          value: option.levelOfCover
        }),
        payment: _objectSpread(_objectSpread({}, demoVariation.payment), {}, {
          base: demoVariation.payment.base - option.excess / 100 + planAdjust,
          total: demoVariation.payment.total - option.excess / 100 + planAdjust
        })
      });
    });
    return _objectSpread(_objectSpread({}, demoResult), {}, {
      variations: adjustedVariations
    });
  };
  return makeFakePlanVariations(planNumber);
};
var MakeFakeQuoteResults = exports.MakeFakeQuoteResults = function MakeFakeQuoteResults(_ref3) {
  var productDefinitions = _ref3.productDefinitions;
  var realMockResults = [].concat(_toConsumableArray(_MockQuoteResults.MockQuoteResults.payLoad.pets[0].petQuotes), _toConsumableArray(_MockQuoteResults.MockQuoteResults.payLoad.pets[1].petQuotes));
  var transformedMockResults = (0, _quoteHelpers.SimplifyQuotePlanResults)({
    productQuotes: realMockResults
  });
  var allProductsKeyedByPlanNumber = (0, _productHelpers.GetAllPlansKeyedByPlanNumber)({
    productDefinitions: productDefinitions
  });
  var fakeQuoteResults = Object.values(allProductsKeyedByPlanNumber).reduce(function (acc, plan) {
    var planNumber = plan.planNumber;
    acc[planNumber] = transformedMockResults[planNumber] || MakeFakeQuoteForPlan({
      transformedMockResults: transformedMockResults,
      productDefinitions: productDefinitions,
      planNumber: planNumber
    });
    return acc;
  }, {});
  return fakeQuoteResults;
};
var GetFakeProductQuotes = exports.GetFakeProductQuotes = function GetFakeProductQuotes(_ref4) {
  var productDefinitions = _ref4.productDefinitions,
    frequency = _ref4.frequency;
  return MakeFakeQuoteResults({
    productDefinitions: productDefinitions,
    frequency: frequency
  });
};